module.exports = __webpack_public_path__ + "img/trashhover.886fcba2.svg";